import * as React from 'react';
import { SuperCriticalComponent } from 'lib/supercritical';
import { FocusGroup, FocusEventHandlers } from 'lib/focusGroup';

import { FeetInchesMetersEdit } from './model';

import { FeetAndInches } from 'portcall/feetandinches/view';
import { ConvertedMeasurementView } from 'portcall/convertedmeasurement/view';

interface FeetInchesMetersEditProps {
    model : FeetInchesMetersEdit,
    disabled? : boolean;
    tabindex? : { feet? : number, inches? : number, meters? : number };
    autoFocus? : boolean;
    onFocus? : () => void;
    onBlur? : () => void;
}

export class FeetInchesMetersEditView extends SuperCriticalComponent<FeetInchesMetersEditProps> {
    feetFocus   : FocusEventHandlers;
    metersFocus : FocusEventHandlers;

    constructor(props : FeetInchesMetersEditProps) {
        super(props);

        const focusGroup = new FocusGroup({
            onFocus: () => this.sprops().onFocus?.(),
            onBlur:  () => this.sprops().onBlur ?.()
        });
        this.feetFocus   = focusGroup.enroll().events;
        this.metersFocus = focusGroup.enroll().events;
    }

    srender({ model, disabled, tabindex, autoFocus } : FeetInchesMetersEditProps) {
        return (
            <div className="feetinchesmetersedit">
                <FeetAndInches
                    model={model.FeetAndInches}
                    disabled={disabled}
                    tabindex={{
                        feet:   (tabindex || {}).feet,
                        inches: (tabindex || {}).inches
                    }}
                    autoFocus={autoFocus}
                    {...this.feetFocus}
                />
                <span className="feetinchesmeters-separator"></span>
                <ConvertedMeasurementView
                    model={model.Meters}
                    disabled={disabled}
                    tabindex={(tabindex || {}).meters}
                    {...this.metersFocus}
                />
                <span className="feetinchesmeters-uom">m</span>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/feetinchesmetersedit/view.tsx